import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { mostrarModulo, actualizarMensaje } from "../../redux/actions/actGlobal";
import { mostrarModalDel } from "../../redux/actions/actGenericas";
import { obtenerValores, obtenerPermisosValor, obtenerPermisosValorAlt, formulario, mostrarError, obtenerValoresFiltros } from "../../global/js/funciones";
import SolicitudesForm from "./SolicitudesForm";
import {TIPOS_IDENTIFICACION, DEPARTAMENTOS, COMUNIDAD, GENERO, REQUISITOS_CONSULTORIA,AREA_DERECHO, TIPOS_CONSULTORIA, RANGO_EDAD, ESTRATO_SOCIOECONOMICO, GRADO_ESCOLARIDAD, VICTIMA_VIOLENCIA, DISCAPACIDADES, DOCUMENTOS_INFORMATIVOS, transformarDiscapacidades, banderaDiscapacidad} from './helper';


class SolicitudesAgregar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tipos_identificacion: [],
      area_derecho: [],
      programas:[],
      programa:'',
      tipo_identificacion: '',
      area:'',
      identificacion: '',
      primer_nombre: '',
      segundo_nombre: '',
      primer_apellido: '',
      segundo_apellido: '',
      telefono: '',
      correo: '',
      departamentos: [],
      departamento: '',
      ciudades: [],
      ciudad: '',
      barrio: '',
      direccion: '',
      comunidad:'',
      egresado:false,
      comunidades:[],
      generos:[],
      requisitos:[],
      archivos: [],
      archivos2:[],
      genero:'',
      anho:'',
      adj_identificacion: '',
      adj_identificacion_final: '',
      tipo_discapacidad_consultorio:'',
      tipos_discapacidad: [],
      // Campos sociodemográficos
      rango_edad: '',
      rangos_edad: [],
      nacionalidad: '',
      estrato_socioeconomico: '',
      estratos: [],
      grado_escolaridad: '',
      grados_escolaridad: [],
      victima_violencia: '',
      victima_violencias: [],
      cabeza_familia: '',
      cabezas_familia: [
        { value: '1', label: 'SI' },
        { value: '0', label: 'NO' },
      ],
      sabe_leer: '',
      opciones_sabe_leer: [
        { value: '1', label: 'SI' },
        { value: '0', label: 'NO' },
      ],
      hechos:'',
      Pretensiones:'',
      identidad_doc:'',
      identidad_doc_final:'',
      adjuntoOpcionales:false,
      tipos_consultorias: [],
      tipo_consultoria: '',
      citaSeleccionada: null,
      tipos_consultoriavirtual:'',
      doc_informativos: [],
    }
  }

  componentDidMount() {
    this.cargarTipos();
    this.cargarTiposVirtual();
  }

  async componentDidUpdate({}, { departamento }) {
    let { departamento: departamentoNew } = this.state;
    if (departamentoNew.value !== departamento.value) {
      let ciudades = await obtenerPermisosValor(departamentoNew.value);
      ciudades = ciudades.map(({ secundario }) => ({
        value: secundario.id,
        label: secundario.nombre,
      }));

      this.changeState('ciudades', ciudades);
      this.changeState('ciudad', '');
    }
  }

  changeState = (name, value) => {
    this.setState({
      [name]: value
    })
  }

  guardarSolicitud = async (archivos) => {
    let {actualizarMensaje } = this.props;
    actualizarMensaje({ titulo: 'Enviado datos, por favor espere...', tipo: 'info', mostrar: true, tiempo: 4000 });
    let {
      tipo_identificacion, area, identificacion, primer_nombre, segundo_nombre,
      primer_apellido, segundo_apellido, telefono, departamento, ciudad, barrio,
      direccion, comunidad, genero, programa, anho, tipo_discapacidad_consultorio, hechos, Pretensiones,
      archivos2, correo, tipo_consultoria, citaSeleccionada, tipos_consultoriavirtual,
      rango_edad, nacionalidad, estrato_socioeconomico, grado_escolaridad,
      victima_violencia, cabeza_familia, sabe_leer,
    } = this.state;
    const data = new FormData();
    archivos.map(({ archivo, codigo }, index) => {
      data.append(`archivo${index}`, archivo);
      data.append(`codigo${index}`, codigo);
      return true;
    });
    archivos2.map((file, index) => data.append(`archivo2${index}`, file));
    data.append('total', archivos.length);
    data.append('total2', archivos2.length);
    data.append('hechos', hechos);
    data.append('Pretensiones', Pretensiones);
    data.append('tipo_discapacidad_consultorio', tipo_discapacidad_consultorio.value);
    data.append('discapacidad', banderaDiscapacidad(tipo_discapacidad_consultorio.value));
    data.append('tipo_identificacion', tipo_identificacion.value);
    data.append('area', area.value);
    data.append('identificacion', identificacion);
    data.append('telefono', telefono);
    data.append('correo', correo);
    data.append('primer_nombre', primer_nombre);
    data.append('segundo_nombre', segundo_nombre);
    data.append('primer_apellido', primer_apellido);
    data.append('segundo_apellido', segundo_apellido);
    data.append('departamento', departamento.value);
    data.append('ciudad', ciudad.value);
    data.append('comunidad', comunidad.value);
    data.append('genero', genero.value);
    data.append('lugar_residencia', barrio);
    data.append('direccion', direccion);
    // Campos sociodemográficos
    if (rango_edad) data.append('rango_edad', rango_edad.value);
    data.append('nacionalidad', nacionalidad);
    if (estrato_socioeconomico) data.append('estrato_socioeconomico', estrato_socioeconomico.value);
    if (grado_escolaridad) data.append('grado_escolaridad', grado_escolaridad.value);
    if (victima_violencia) data.append('victima_violencia', victima_violencia.value);
    if (cabeza_familia) data.append('cabeza_familia', cabeza_familia.value);
    if (sabe_leer) data.append('sabe_leer', sabe_leer.value);
    data.append(
    'tipo_consultoria',
     this.props.virtual
        ? tipos_consultoriavirtual
        : tipo_consultoria.value
   );
    if(programa !== ''){
      data.append('programa', programa.value);
    }
    if(anho !== ''){
      data.append('anho', anho);
    }
    data.append('estudiante_id', citaSeleccionada?.estudiante_id ?? 0);
   /*  data.append('estudiante_id', citaSeleccionada && citaSeleccionada.estudiante_id ? citaSeleccionada.estudiante_id : null); */
      /* data.append('fecha_cita', citaSeleccionada.fecha);
      data.append('hora_inicio_cita', citaSeleccionada.horaInicio);
      data.append('hora_fin_cita', citaSeleccionada.horaFin);
      data.append('estudiante_consultoria_id', citaSeleccionada.estudiante_id); */
    formulario("api/v1.0/consultoria/crear", data, "post",
      (error, estado, resp) => {
        let titulo = 'Ha ocurrido un error, contacte con el administrador.', tipo = 'error';
        if (!error) {
          if (estado === 200) {
            tipo = 'success';
            titulo = resp.titulo;
            this.reset()
          } else {
            tipo = 'info';
            titulo = resp.titulo ? resp.titulo : mostrarError(resp);
          }
        }
        actualizarMensaje({ titulo, tipo, mostrar: true, tiempo: 6000 });
      }, false
    );

  }

  reset(){
    this.setState({
      tipo_identificacion: '',
      area:'',
      identificacion: '',
      primer_nombre: '',
      segundo_nombre: '',
      primer_apellido: '',
      segundo_apellido: '',
      telefono: '',
      correo: '',
      ciudad: '',
      barrio: '',
      direccion: '',
      comunidad:'',
      archivos: [],
      archivos2:[],
      genero:'',
      anho:'',
      adj_identificacion: '',
      adj_identificacion_final: '',
      tipo_discapacidad_consultorio:'',
      hechos:'',
      Pretensiones:'',
      identidad_doc:'',
      identidad_doc_final:'',
      adjuntoOpcionales:false,
      egresado:false,
      programa:'',
      tipo_consultoria: '',
      citaSeleccionada: null,
      // Campos sociodemográficos
      rango_edad: '',
      nacionalidad: '',
      estrato_socioeconomico: '',
      grado_escolaridad: '',
      victima_violencia: '',
      cabeza_familia: '',
      sabe_leer: '',
    })
  }
  cambiarEstado = (estados) => {
    this.setState(estados)
  }

  onChange = ({ target }) => {
    let { value, name } = target;
      this.setState({
        [name]: value
      })
  }
  eliminarArchivo = (i) => {
    let { actualizarMensaje } = this.props;
    let{archivos2}= this.state;
    archivos2.splice(i, 1)
    this.setState({ archivos2 })
    actualizarMensaje({ titulo: `Archivo Retirado.`, tipo: 'success', mostrar: true, tiempo: 6000 })
  }

  agregarArchivos = (arc) => {
    let{archivos2}= this.state;
    archivos2 = archivos2.concat(arc);
    this.setState({ archivos2 })
  }

  checked = ({target}) => {
    this.setState({
      [target.name]: target.checked
    })
  }

  actualizarCita = (cita) => {
    this.setState({
      citaSeleccionada: cita
    })
  }
  
  submit = (archivos) => {
    let {requisitos} =this.state
    let {actualizarMensaje } = this.props;
    let contador=0
    let contador2=0
    requisitos.map((info)=>{
      if(info.valora === '1'){
        contador=contador + 1;
        archivos.map((j)=>{
          if(j.codigo === info.id){
            contador2=contador2+1
          }
        })
      }
      
    })
     if (contador2 >= contador) {
      this.guardarSolicitud(archivos)
    } else actualizarMensaje({ titulo: 'Debe adjuntar los documentos que son obligatorio', tipo: 'info', mostrar: true, tiempo: 6000 });

  }

  cargarTipos = async () => {
    const transformar = data => {
      return data.map(e => ({
        value: e.id,
        label: e.nombre,
        codigo: e.codigo,
      }));
    }
    const tipos_identificacion = await obtenerValores(TIPOS_IDENTIFICACION);
    const departamentos = await obtenerValores(DEPARTAMENTOS);
    const comunidades = await obtenerValores(COMUNIDAD);
    const generos = await obtenerValores(GENERO);
    const requisitos = await obtenerValores(REQUISITOS_CONSULTORIA);
    const programas = await obtenerValores(5);
    const area_derecho = await obtenerValores(AREA_DERECHO);
    const tipos_consultorias = await obtenerValores(TIPOS_CONSULTORIA);
    const rangos_edad = await obtenerValores(RANGO_EDAD);
    const estratos = await obtenerValores(ESTRATO_SOCIOECONOMICO);
    const grados_escolaridad = await obtenerValores(GRADO_ESCOLARIDAD);
    const victima_violencias_raw = await obtenerValores(VICTIMA_VIOLENCIA);
    const discapacidades_raw = await obtenerValores(DISCAPACIDADES);
    this.setState({
      requisitos,
      tipos_identificacion: transformar(tipos_identificacion),
      departamentos: transformar(departamentos),
      comunidades: transformar(comunidades),
      generos: transformar(generos),
      programas: transformar(programas),
      area_derecho:transformar(area_derecho),
      tipos_consultorias: transformar(tipos_consultorias),
      rangos_edad: transformar(rangos_edad),
      estratos: transformar(estratos),
      grados_escolaridad: transformar(grados_escolaridad),
      victima_violencias: transformar(victima_violencias_raw),
      tipos_discapacidad: transformarDiscapacidades(discapacidades_raw),
      cargando : false
    })
    const doc_informativos_raw = await obtenerPermisosValorAlt([{ 'llave': 'principal__codigo', 'valor': 'consultoria_admin_act' }, { 'llave': 'secundario__generica', 'valor': DOCUMENTOS_INFORMATIVOS }]);
    this.setState({ doc_informativos: doc_informativos_raw.map(({ secundario }) => secundario) })
  }

  cargarTiposVirtual = async () => {

  const tipos_consultorias = await obtenerValores(TIPOS_CONSULTORIA);

  const tipoVirtual = tipos_consultorias.find(
    e => e.codigo === "Consul_Sol_Virt"
  );

  this.setState({
    tipos_consultoriavirtual: tipoVirtual ? tipoVirtual.id : null
  });
}




  validarDatos = (step) => {
    let {
      tipo_identificacion,
      area,
      identificacion,
      primer_nombre,
      primer_apellido,
      telefono,
      correo,
      departamento,
      ciudad,
      barrio,
      direccion,
      comunidad,
      genero,
      tipo_discapacidad_consultorio,
      hechos,
      Pretensiones,
      tipo_consultoria,
      citaSeleccionada
    } = this.state;
    let mensaje = '';
    if(step === 1) {
      if (!tipo_consultoria && !this.props.virtual) mensaje = 'Por favor su tipo de asesoria.';
      else if (!area) mensaje = 'Por favor seleccione tipo de area.';
      else if (!Pretensiones) mensaje = 'Por favor escriba las pretensiones.';
      else if (!hechos) mensaje = 'Por favor escriba los hechos.';
    }
    if(step === 2 && this.props.virtual) {
      if (!citaSeleccionada) mensaje = 'Por favor seleccione una cita disponible.';
    }
    if(step === 0) {
      if (!tipo_identificacion) mensaje = 'Seleccione tipo identificación.';
      else if (!identificacion) mensaje = 'Ingrese #identificación.';
      else if (!primer_nombre) mensaje = 'Ingrese primer nombre.';
      else if (!primer_apellido) mensaje = 'Ingrese primer apellido.';
      else if (!telefono) mensaje = 'Ingrese telefono.';
      else if (!correo) mensaje = 'Ingrese correo.';
      else if (!departamento) mensaje = 'Ingrese departamento.';
      else if (!ciudad) mensaje = 'Ingrese ciudad.';
      else if (!barrio) mensaje = 'Ingrese barrio.';
      else if (!direccion) mensaje = 'Ingrese direccion.';
      else if (!comunidad) mensaje = 'Ingrese tcomunidad.';
      else if (!genero) mensaje = 'Ingrese genero.';
      else if (!tipo_discapacidad_consultorio) mensaje = 'Ingrese discapacidad.';
    }
    return mensaje;
  }


  render() {
    let {
      tipo_identificacion, programas, programa, tipos_identificacion, area_derecho, area,
      identificacion, primer_nombre, segundo_nombre, primer_apellido, segundo_apellido,
      barrio, direccion, departamentos, departamento, ciudades, ciudad, telefono, correo,
      comunidades, comunidad, tipo_discapacidad_consultorio, tipos_discapacidad, genero, generos,
      hechos, Pretensiones, anho, requisitos, archivos, archivos2, egresado, adjuntoOpcionales,
      tipo_consultoria, tipos_consultorias, citaSeleccionada,
      rango_edad, rangos_edad, nacionalidad,
      estrato_socioeconomico, estratos, grado_escolaridad, grados_escolaridad,
      victima_violencia, victima_violencias, cabezas_familia,
      sabe_leer, opciones_sabe_leer,
      doc_informativos,
    } = this.state;
    let { actualizarMensaje, virtual } = this.props;

    return (
      <div>
        <SolicitudesForm
          props_c={{
            obtenerValores: () => obtenerValores,
            tipo_identificacion, tipos_identificacion, area_derecho, area,
            identificacion, primer_nombre, segundo_nombre, primer_apellido, segundo_apellido,
            barrio, archivos2, direccion, departamentos, departamento, ciudades, ciudad,
            telefono, correo, comunidad, comunidades,
            tipo_discapacidad_consultorio, tipos_discapacidad,
            genero, generos, hechos, Pretensiones, egresado, requisitos, archivos,
            programas, programa, anho, adjuntoOpcionales,
            onChange: this.onChange,
            submit: this.submit,
            checked: this.checked,
            validarDatos: this.validarDatos,
            eliminarArchivo: this.eliminarArchivo,
            agregarArchivos: this.agregarArchivos,
            cambiarEstado: this.cambiarEstado,
            actualizarMensaje,
            tipo_consultoria, tipos_consultorias,
            setTipo_identificacion: (value) => this.changeState('tipo_identificacion', value),
            setDepartamento: (value) => this.changeState('departamento', value),
            setPrograma: (value) => this.changeState('programa', value),
            setCiudad: (value) => this.changeState('ciudad', value),
            setGenero: (value) => this.changeState('genero', value),
            setComunidad: (value) => this.changeState('comunidad', value),
            setTipo_discapacidad: (value) => this.changeState('tipo_discapacidad_consultorio', value),
            setArea_derecho: (value) => this.changeState('area', value),
            setTipo_Consultoria: (value) => this.changeState('tipo_consultoria', value),
            actualizarCita: this.actualizarCita,
            citaSeleccionada, virtual,
            doc_informativos,
            // Campos sociodemográficos
            rango_edad, rangos_edad, nacionalidad,
            estrato_socioeconomico, estratos, grado_escolaridad, grados_escolaridad,
            victima_violencia, victima_violencias, cabezas_familia,
            sabe_leer, opciones_sabe_leer,
            setRango_edad: (value) => this.changeState('rango_edad', value),
            setEstrato: (value) => this.changeState('estrato_socioeconomico', value),
            setGrado_escolaridad: (value) => this.changeState('grado_escolaridad', value),
            setVictima_violencia: (value) => this.changeState('victima_violencia', value),
            setCabeza_familia: (value) => this.changeState('cabeza_familia', value),
            setSabe_leer: (value) => this.changeState('sabe_leer', value),
          }}
        />
      </div>
    )
  }
}

//CARGO ESTADOS DEL MODULO
const mapStateToProps = (state) => {
  let { modalDel } = state.redGenericas;
  return {
    modalDel,
  }
};

//CARGO FUNCIONES DEL MODULO
const mapDispatchToProps = {
  actualizarMensaje,
  mostrarModulo,
  mostrarModalDel,
}

SolicitudesAgregar.propTypes = {
  //variables
  modalDel: PropTypes.bool.isRequired,
  actualizarMensaje: PropTypes.func.isRequired,
  mostrarModulo: PropTypes.func.isRequired,
  mostrarModalDel: PropTypes.func.isRequired,
  virtual: PropTypes.bool.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(SolicitudesAgregar);
